import { useFeatureFlagEnabled, useFeatureFlagPayload, useFeatureFlagVariantKey } from 'posthog-js/react'
import { POSTHOG_FEATURE_FLAG_DEFAULTS, type PostHogFeatureFlag } from './posthogFeatureFlags'

export function usePostHogFeatureFlag(key?: PostHogFeatureFlag): boolean {
  // Hook is always invoked (rules-of-hooks); callers may pass an optional flag.
  // `useFeatureFlagEnabled` is `undefined` while flags load / PostHog is
  // unconfigured / the key is missing — fall back to the configured default.
  const enabled = useFeatureFlagEnabled(key as string)
  if (!key) {
    return false
  }
  return enabled ?? POSTHOG_FEATURE_FLAG_DEFAULTS[key] ?? false
}

export function usePostHogFeatureFlagVariant(key: PostHogFeatureFlag): string | boolean | undefined {
  return useFeatureFlagVariantKey(key)
}

export function usePostHogFeatureFlagPayload<T = unknown>(key: PostHogFeatureFlag): T | undefined {
  return useFeatureFlagPayload(key) as T | undefined
}
